import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import { FormattedMessage } from 'react-intl'
import Modal from './Modal/Modal'

export default class NewSeminarButton extends Component {
  handleOpen = () => this.refs.modal.handleOpen()

  render () {
    return (
      <div>
        <RaisedButton
          onTouchTap={this.handleOpen}
          fullWidth
          backgroundColor='#FCCE42'
          labelStyle={{color: '#8B7124'}}
          label={(this.props.guest) ? (
            <FormattedMessage id='loggedInNavigation.upgrade'/>
          ) : <FormattedMessage id='loggedInNavigation.new'/>}
          style={{height: 42}}/>
        <Modal
          user={this.props.user}
          returnUserIfUserExists={this.props.returnUserIfUserExists}
          upgradeUser={this.props.upgradeUser}
          createConference={this.props.createConference}
          ref='modal'
          newSeminar={this.props.newSeminar}
          open={this.props.open}
          guest={this.props.guest}
          accountType={this.props.accountType}
          newSeminarUpgradeModal={this.props.newSeminarUpgradeModal}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/NewSeminarButton.js